import PropTypes from 'prop-types';
import React from 'react';

const SvgIcon = props => (
    <svg
        role="img"
        aria-hidden={props.ariaHidden}
        className={props.class}
        aria-labelledby={`${props.id}_title_${props.index}`}
        aria-describedby={`${props.id}_description_${props.index}`}
        aria-label={`${props.id}_title_${props.index}`}
    >
        <title id={`${props.id}_title_${props.index}`}>{props.ariaLabelledBy}</title>
        <desc id={`${props.id}_description_${props.index}`}>{props.ariaDescribedBy}</desc>
        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`#svg-${props.id}`} />
    </svg>
);

SvgIcon.propTypes = {
    class: PropTypes.string,
    id: PropTypes.string.isRequired,
    ariaLabelledBy: PropTypes.string,
    ariaDescribedBy: PropTypes.string,
    ariaHidden: PropTypes.bool,
    index: PropTypes.number,
};

SvgIcon.defaultProps = {
    class: '',
    ariaHidden: false,
    ariaLabelledBy: '',
    ariaDescribedBy: '',
    index: 0,
};

export default SvgIcon;
